'use client';
import { usePathname } from 'next/navigation';

type Props = {};

export const CurrentPath: React.FC<Props> = () => {
  const pathname = usePathname();

  return pathname.replace(/\/+$/, '');
};
